import * as angular from "angular";
import type { FormSession } from "./form-session";
import {
	elementState,
	FormUiSchema
} from "../runtime";

interface InputContext {
	path: string;
	session: FormSession;
	ui: FormUiSchema;
	basePath: string;
}

/** A context refresh can hide a control before Angular removes its old DOM. */
export function hasInvalidVisibleInput(element: Element): boolean {
	return Array.from(element.querySelectorAll("[ng-model], [data-ng-model], [x-ng-model]"))
		.some(input => {
			const model = angular.element(input).data("$ngModelController") as angular.INgModelController | undefined;

			if(model?.$valid !== false) {
				return false;
			}

			let ancestor: Element | null = input;

			while(ancestor) {
				const context = angular.element(ancestor).data("$jsonSchemaNodeController") as InputContext | undefined;

				if(context) {
					const runtime = context.session.runtime;
					const visible = elementState(context.ui, runtime.data, context.basePath, runtime.ajv).visible;

					if(!visible || !runtime.isVisible(context.path)) {
						return false;
					}
				}

				if(ancestor === element) {
					break;
				}

				ancestor = ancestor.parentElement;
			}

			return true;
		});
}
